import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import './index.scss';
import LazyLoadImage from '../../atoms/image/Image';
import { OPTINCTA_COMPONENT, GILD_EVENT, BUTTONS, CLICKED } from '../../../constants';
import {PushDataLayerObject} from '../../../utility';

  const Anchor = ({data, onClick, tabIndex, hasFixed=false}) => {

    const conditionalClasses = !hasFixed ? 'fixed bottom-0 left-0 right-0 flex justify-center z-50 p-4 mb-0 md:relative md:bottom-auto md:left-auto md:right-auto md:z-auto md:p-0 md:mb-4 home-cta': '';

    const configuration = useSelector((state) => state.configuration);

    const object = data.id === OPTINCTA_COMPONENT ? data.object.cta : data.object;
    const eventDetails = data.id === OPTINCTA_COMPONENT ? null : data.object.event;

    const onClickAnchor = (e) => {
      if (configuration && eventDetails) {
        PushDataLayerObject(
          configuration,
          GILD_EVENT, 
          BUTTONS,
          CLICKED,
          eventDetails.label
          )
      }
      if(onClick)onClick(e);
    }

  return (data &&
    
    <div className={`cta-div text-center ${conditionalClasses} px-4`}>
      <Link role="button" tabIndex={tabIndex} onClick={onClickAnchor} className='flex items-center justify-center text-center bg-primary-900 hover:bg-opacity-75 transition-colors duration-200 rounded-full font-semibold cta sm:my-4 px-6 py-3 text-base h-12' to={ object.link }>
           {object.text}
           {(object.iconImage && object.iconImage !== '') &&
               <LazyLoadImage className='w-5 ml-2' src={object.iconImage} alt={object.text} />
           }
       </Link>
    </div>
  )
}

export default Anchor;

